module.exports = __webpack_public_path__ + "static/media/rainRoom.a60c79a8.jpg";